const getTimestampInXDays = days => {
    const daysAmount = parseInt(days)
    const date = new Date()
    date.setDate(date.getDate() + daysAmount)
    const endDate = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    return endDate
}

export default getTimestampInXDays 